module.exports = __webpack_public_path__ + "img/global-1982-schramm.fd0e9922.jpg";